import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Notificaciones from './Components/Notificaciones';
import AjustesNotificaciones from './Components/AjustesNotificaciones';

export default class AdmNotificaciones extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<Notificaciones/>}/>
                    <Route path="Ajustes" element={<AjustesNotificaciones/>}/>
                </Routes>
            </div>
        );
    }
}